<template>
  <div>
    <div class="container">
      <spinner :visible="is_loading" :overlay="true"></spinner>
      <div name="upload_form" class="well row-fluid">
        <div class="control-group field">
          File SIAD 1:
          <input
            type="file"
            ref="file_siad_1"
            name="file_siad_1"
            v-on:change="handleFileUploadSiad1()"
            :disabled="!this.import_type"
          /><br /><br />
          <span v-if="errors.uploadFile" class="alert">Estensione del file non supportata!</span>
          <span v-if="errors.parsing" class="alert">Errore nella decodifica del documento!</span>
        </div>

        <div class="control-group field">
          File SIAD 3:
          <input
            type="file"
            ref="file_siad_3"
            name="file_siad_3"
            v-on:change="handleFileUploadSiad3()"
            :disabled="!this.import_type"
          /><br /><br />
          <span v-if="errors.uploadFile" class="alert">Estensione del file non supportata!</span>
          <span v-if="errors.parsing" class="alert">Errore nella decodifica del documento!</span>
        </div>

        <div class="control-group field">
          File SIAD 4:
          <input
            type="file"
            ref="file_siad_4"
            name="file_siad_4"
            v-on:change="handleFileUploadSiad4()"
            :disabled="!this.import_type"
          /><br /><br />
          <span v-if="errors.uploadFile" class="alert">Estensione del file non supportata!</span>
          <span v-if="errors.parsing" class="alert">Errore nella decodifica del documento!</span>
        </div>

        <div>
          <button id="import_file" @click="SiadConverterGenerator()" class="btn btn-primary" :disabled="disableSubmit()">
            {{ i18nJSIndex.import }}
          </button>
        </div>
        <div v-if="file_imported" class="alert alert-success">
          {{ i18nJSIndex.import_ok }}
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import spinner from '../spinner';
import { Route } from '../../route';
import apiConnector from '@/epersonam/apiConnector';

export default {
  name: 'siadConvertersIndex',
  components: {
    spinner,
  },
  props: {
    business_unit_id: { type: Number, required: true },
  },
  data: function () {
    return {
      disable_load_more_button: false,
      from_profile: null,
      to_profile: null,
      import_type: { format: 'txt' },
      file_siad_1: '',
      file_siad_3: '',
      file_siad_4: '',
      row_count: 0,
      filename: null,
      file_imported: false,
      is_loading: false,

      dataTable: [],

      page: 0,
      lengthPage: 10,

      errors: {
        uploadFile: false,
        parsing: false,
      },
    };
  },
  mounted() {},
  watch: {},
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    i18nJSIndex() {
      return this.i18nJS.siad_imports.index;
    },
    SiadConverterUrl() {
      return `${Route.SIAD_CONVERTERS}/converter`;
    },
    getS3DircectPostUrl() {
      return `${Route.SIAD_CONVERTERS}/get_s3_direct_post`;
    },
  },
  methods: {
    disableSubmit() {
      return false;

      // return !(this.from_profile && this.to_profile && this.file)
    },
    handleFileUploadSiad1() {
      const tmpRefFile = this.$refs.file_siad_1.files[0];

      if (tmpRefFile && tmpRefFile.name.endsWith(`.${this.import_type.format}`)) {
        this.errors.uploadFile = false;
        this.errors.parsing = false;
        this.file_siad_1 = tmpRefFile;
      } else if (tmpRefFile && !tmpRefFile.name.endsWith(`.${this.import_type.format}`)) {
        console.error('File format not supported');
        this.errors.uploadFile = true;
      } else {
        console.error('Some problem during upload of file');
        this.errors.uploadFile = true;
      }
    },
    handleFileUploadSiad3() {
      const tmpRefFile = this.$refs.file_siad_3.files[0];

      if (tmpRefFile && tmpRefFile.name.endsWith(`.${this.import_type.format}`)) {
        this.errors.uploadFile = false;
        this.errors.parsing = false;
        this.file_siad_3 = tmpRefFile;
      } else if (tmpRefFile && !tmpRefFile.name.endsWith(`.${this.import_type.format}`)) {
        console.error('File format not supported');
        this.errors.uploadFile = true;
      } else {
        console.error('Some problem during upload of file');
        this.errors.uploadFile = true;
      }
    },
    handleFileUploadSiad4() {
      const tmpRefFile = this.$refs.file_siad_4.files[0];

      if (tmpRefFile && tmpRefFile.name.endsWith(`.${this.import_type.format}`)) {
        this.errors.uploadFile = false;
        this.errors.parsing = false;
        this.file_siad_4 = tmpRefFile;
      } else if (tmpRefFile && !tmpRefFile.name.endsWith(`.${this.import_type.format}`)) {
        console.error('File format not supported');
        this.errors.uploadFile = true;
      } else {
        console.error('Some problem during upload of file');
        this.errors.uploadFile = true;
      }
    },
    SiadConverterGenerator() {
      this.is_loading = true;

      const FD = new FormData();

      FD.append('file_siad_1', this.file_siad_1);
      FD.append('file_siad_3', this.file_siad_3);
      FD.append('file_siad_4', this.file_siad_4);

      axios({
        method: 'post',
        url: this.SiadConverterUrl,
        data: FD,
        headers: {
          'Content-type': 'multipart/form-data',
          'X-CSRF-Token': $.rails.csrfToken(),
        },
      })
        .then((res) => {
          this.dataTable = res.data;
          this.file_imported = true;
          this.is_loading = false;
        })
        .catch((err) => {
          var msg = `${i18nJS.errors.critical_error}: ${err.message} - ${err.response.data}`;
          if (err.response.status === 401) {
            msg = i18nJS.access_denied;
          }
          Utils.appendToFlash('error', msg);
          this.is_loading = false;
        });
    },
  },
};
</script>

<style scoped>
.alert {
  margin-top: 20px;
}
</style>
